import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class ListBillToInfoService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    // private common: DatabaseCacheService
  ) { }

  listBillToInfos(distributorId:string | null, sectionGroupId:string | null, sectionId:string | null) {

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    let headers = new HttpHeaders({'Content-Type': 'application/json'})
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    let params = new HttpParams();

    if (distributorId){
      params = params.set('distributorId', distributorId);
    }
    if (sectionGroupId){
      params = params.set('sectionGroupId', sectionGroupId);
    }
    if (sectionId){
      params = params.set('sectionId', sectionId);
    }

    return this.httpClient.get(`${apiConfig.uri}/bill-to-infos`, {  headers: headers, params: params });      
  }  
}
